













































































import Vue from "vue";
import { mapState } from "vuex";
import { getImage, getName } from "@/utils/data-utils";
import { Seiyuu } from "@/store";

export default Vue.extend({
  name: "SearchSeiyuu",

  props: ["mini"],

  data: () => ({
    menuData: undefined as any
  }),

  methods: {
    getName(seiyuu: Seiyuu) {
      return getName(seiyuu);
    },
    getImage(seiyuu: Seiyuu) {
      return getImage(seiyuu);
    }
  },

  computed: {
    ...mapState([
      "searchSeiyuuResult",
      "selectedSeiyuu",
      "recentAnime",
      "loadingResult"
    ])
  }
});
